<script>
    import {PAGE_ID, router, navigateTo} from "../../stores/router";
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.PLANNER}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!-- <Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center md:justify-between">
            <div class="min-w-0 flex-1">
                <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Planner</h2>
            </div>
            <div class="flex flex-shrink-0 md:mt-0 md:ml-4">
                <!-- <button type="button" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Edit</button>-->
                <!-- <button type="button" class="ml-3 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Publish</button>-->
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="px-4 sm:px-6 lg:px-8">

        <div class="my-4">

        </div>

<!--        <p>-->
<!--            Today I spent most of the day researching ways to ...-->
<!--            <span class="inline-flex items-baseline">-->
<!--                <svg class=" self-center h-4 w-4 text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">-->
<!--                    <path d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z" />-->
<!--                </svg>-->
<!--            </span>-->
<!--                <span>Kramer is a plonker who causes no end of rubbish to be spewed</span>-->
<!--            keeps telling me there is no way to make it work, that ...-->
<!--        </p>-->

        <!-- Person pill-->
        <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">
            <svg class="h-4 w-4 text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z" />
            </svg>
            <p class="ml-1 text-sm uppercase font-light text-gray-600">Person</p>
        </div>

        <!-- Company pill-->
        <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">
            <svg class="h-4 w-4 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M4 16.5v-13h-.25a.75.75 0 010-1.5h12.5a.75.75 0 010 1.5H16v13h.25a.75.75 0 010 1.5h-3.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-3.5a.75.75 0 010-1.5H4zm3-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM7.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM11 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z" clip-rule="evenodd" />
            </svg>
            <p class="ml-1 text-sm uppercase font-light text-gray-600">Company</p>
        </div>

        <!-- Request pill-->
        <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">
            <svg class="h-4 w-4 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
            </svg>
            <p class="ml-1 text-sm uppercase font-light text-gray-600">Request</p>
        </div>

        <!-- Deal pill-->
        <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">
            <svg class="h-4 w-4 text-pink-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.732 6.232a2.5 2.5 0 013.536 0 .75.75 0 101.06-1.06A4 4 0 006.5 8v.165c0 .364.034.728.1 1.085h-.35a.75.75 0 000 1.5h.737a5.25 5.25 0 01-.367 3.072l-.055.123a.75.75 0 00.848 1.037l1.272-.283a3.493 3.493 0 011.604.021 4.992 4.992 0 002.422 0l.97-.242a.75.75 0 00-.363-1.456l-.971.243a3.491 3.491 0 01-1.694 0 4.992 4.992 0 00-2.258-.038c.19-.811.227-1.651.111-2.477H9.75a.75.75 0 000-1.5H8.136A4.397 4.397 0 018 8.165V8c0-.641.244-1.28.732-1.768z" clip-rule="evenodd" />
            </svg>
            <p class="ml-1 text-sm uppercase font-light text-gray-600">Deal</p>
        </div>

        <!-- Promotion pill-->
        <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">
            <svg class="h-4 w-4 text-purple-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path d="M3.505 2.365A41.369 41.369 0 019 2c1.863 0 3.697.124 5.495.365 1.247.167 2.18 1.108 2.435 2.268a4.45 4.45 0 00-.577-.069 43.141 43.141 0 00-4.706 0C9.229 4.696 7.5 6.727 7.5 8.998v2.24c0 1.413.67 2.735 1.76 3.562l-2.98 2.98A.75.75 0 015 17.25v-3.443c-.501-.048-1-.106-1.495-.172C2.033 13.438 1 12.162 1 10.72V5.28c0-1.441 1.033-2.717 2.505-2.914z" />
                <path d="M14 6c-.762 0-1.52.02-2.271.062C10.157 6.148 9 7.472 9 8.998v2.24c0 1.519 1.147 2.839 2.71 2.935.214.013.428.024.642.034.2.009.385.09.518.224l2.35 2.35a.75.75 0 001.28-.531v-2.07c1.453-.195 2.5-1.463 2.5-2.915V8.998c0-1.526-1.157-2.85-2.729-2.936A41.645 41.645 0 0014 6z" />
            </svg>
            <p class="ml-1 text-sm uppercase font-light text-gray-600">Promotion</p>
        </div>

        <h3>Requests (Inbound)</h3>
        <ol>
            <li>[to-reply] [Jeff Blogs] nutritionist in LA for March</li>
            <li>[to-reply] [Jeff Blogs] adventure holiday for family</li>
            <li>[to-reply] [Jeff Blogs] bike for home gym</li>
            <li>[in-flight] [Jeff Blogs] [ACME Corp] gym install at Co. HQ</li>
            <li>[in-flight] [Jeff Blogs] how do I climb Mount Everest?</li>
        </ol>
        <h3>Promotions (Outbound)</h3>
        <ol>
            <li>[sending] Meal at Restaurant X [ACME Corp.] [Shortlist 80/100]</li>
            <li>[sending] Adventure Trip [ACME Corp.] [Shortlist 80/100]</li>
            <li>[preparing] Red Bull Cross Europe Race [ACME Corp.] [No Shortlist]</li>
        </ol>
        <h3>Deals</h3>
        <ol>
            <li>[outreach] [ACME Corp] sale of boats in Monaco - 20% commission</li>
            <li>[negotiating] [ACME Corp] sale of boats in Monaco - 20% commission</li>
            <li>[negotiating] [ACME Corp] sale of boats in Monaco - 20% commission</li>
        </ol>

    </div>
</div>


<style></style>